import { useState, useEffect } from 'react';

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const percent = docHeight > 0 ? Math.round((scrollY / docHeight) * 100) : 0;
      setVisible(scrollY > 400);
      setScrollPercent(percent);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const radius = 20;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (scrollPercent / 100) * circumference;

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Наверх"
      className="fixed bottom-24 right-8 z-50 cursor-pointer"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.8)',
        transition: 'opacity 0.35s cubic-bezier(0.22,1,0.36,1), transform 0.35s cubic-bezier(0.22,1,0.36,1)',
        pointerEvents: visible ? 'auto' : 'none',
      }}
    >
      {/* Tooltip */}
      <div
        className="absolute bottom-full right-0 mb-2 px-2.5 py-1 rounded-lg font-mono text-[10px] whitespace-nowrap pointer-events-none"
        style={{
          background: 'rgba(5,5,8,0.95)',
          border: '1px solid rgba(255,45,120,0.25)',
          color: 'rgba(255,255,255,0.55)',
          opacity: hovered ? 1 : 0,
          transform: hovered ? 'translateY(0)' : 'translateY(6px)',
          transition: 'opacity 0.2s ease, transform 0.2s ease',
        }}
      >
        Наверх · {scrollPercent}%
      </div>

      {/* Outer ring with progress */}
      <div className="relative w-12 h-12 flex items-center justify-center">
        {/* SVG progress ring */}
        <svg
          className="absolute inset-0 w-full h-full -rotate-90"
          viewBox="0 0 48 48"
        >
          {/* Track */}
          <circle
            cx="24"
            cy="24"
            r={radius}
            fill="none"
            stroke="rgba(255,45,120,0.15)"
            strokeWidth="2"
          />
          {/* Progress arc */}
          <circle
            cx="24"
            cy="24"
            r={radius}
            fill="none"
            stroke="#ff2d78"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            style={{
              transition: 'stroke-dashoffset 0.3s ease',
              filter: 'drop-shadow(0 0 4px rgba(255,45,120,0.8))',
            }}
          />
        </svg>

        {/* Inner button face */}
        <div
          className="relative z-10 w-9 h-9 flex items-center justify-center rounded-full transition-all duration-300"
          style={{
            background: hovered ? 'rgba(255,45,120,0.12)' : 'rgba(5,5,8,0.95)',
            border: `1px solid ${hovered ? 'rgba(255,45,120,0.6)' : 'rgba(255,45,120,0.3)'}`,
            boxShadow: hovered ? '0 0 18px rgba(255,45,120,0.35)' : '0 0 10px rgba(255,45,120,0.15)',
          }}
        >
          <i
            className="ri-arrow-up-line text-base"
            style={{
              color: '#ff2d78',
              transform: hovered ? 'translateY(-1px)' : 'translateY(0)',
              transition: 'transform 0.25s ease',
              display: 'block',
            }}
          />
        </div>
      </div>
    </button>
  );
};

export default ScrollToTop;
